import React from 'react';
import PropTypes from 'prop-types';
import Dialog from 'components/Ui/Dialog';
import { Button } from 'components/Ui';
import { useIsMobile } from 'utils/hooks';
import { PromotionIcon } from 'images';
import styles from './styles.scss';

const CostcoPromotionDetails = ({ open, setStatus, onClose, content }) => {
  const isMobile = useIsMobile();

  return (
    <Dialog
      isAutoClose={false}
      isCloseIcon
      open={open}
      onClose={setStatus}
      fullScreen={isMobile}
    >
      <div className={styles.promotionDetails}>
        <div className={styles.content}>
          <div className={styles.discountIcon}>
            <img src={PromotionIcon} alt="" />
          </div>
          <div className={styles.title}>{content.title}</div>
          <div className={styles.note}>{content.note}</div>
          <Button className={styles.btn} text="Close" onClick={onClose} />
          <div className={styles.terms}>{content.disclaimer}</div>
        </div>
      </div>
    </Dialog>
  );
};

CostcoPromotionDetails.propTypes = {
  open: PropTypes.bool.isRequired,
  setStatus: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  content: PropTypes.object.isRequired,
};

export default CostcoPromotionDetails;
